import React from "react";
import { useAppSelector } from "../../../../app/hooks";
import StudentDetailsChartPresentation from "../../presantation/student.details.chart.presentation/StudentDetailsChartPresentation";
import { accountSelected } from "../../slice/studentSlice";
import { Student, StudentProjectReport } from "../../types/types";

interface StudentDetailsChartContainerProps {
  student: Student
  projectReport: StudentProjectReport
}
const StudentDetailsChartContainer: React.FC<
StudentDetailsChartContainerProps
> = ({ student, projectReport }) => {
  const account = useAppSelector(accountSelected)

  return (
    <StudentDetailsChartPresentation
      student={student}
      account={account!}
      projectReport={projectReport}
    />
  )
}

export default StudentDetailsChartContainer
